import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { LiveScoreQuery, LiveScoreSubscription } from '../types';

/**
 * typeguard for LiveScoreQuery
 * @param LiveScoreQuery object passed to transformer
 */
export const isValidLiveScoreObject = (obj: LiveScoreQuery): boolean => {

    return Boolean(obj?.data?.getLiveScoreWidget && !isEmptyObject(obj.data.getLiveScoreWidget))
    
};

export const isValidLiveScoreObjecSubscription = (obj: LiveScoreSubscription): boolean => {
   
    return Boolean(obj?.data?.onUpdateLiveScoreWidgetById && !isEmptyObject(obj.data.onUpdateLiveScoreWidgetById))
    
};
